<template>
    <div>
        <el-row>
            <el-col>
                <el-input type="textarea" :rows="10" placeholder="请输入意见" v-model="contentInput"></el-input>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import DataFormService from '@/services/data-form.service.js';
import LoginService from '@/services/login.service';

export default {
    name: 'batch-submit',
    props: {
        selectedItems: Array,
        batchType: Number,
    },
    data: function() {
        return {
            contentInput: '',
            selectValue: '',
            disabled: false,
            options: [{ label: '同意', value: '1' }],
        };
    },

    methods: {
        confirmAction: function() {
            var _type = '';
            if (this.batchType == 0) {
                _type = 'S2Cloud.SmartFlow.Sheet.BatchSubmitButton,S2Cloud.SmartFlow';
            } else {
                _type = 'S2Cloud.SmartFlow.Sheet.BatchReturnButton,S2Cloud.SmartFlow';
            }
            return DataFormService.submitFormData({
                $type: _type,
                WorkItemIds: this.selectedItems,
                CommentText: this.contentInput,
                UserId: LoginService.userInfo.ObjectID,
            }).then(res => {
                if (res.Result) {
                    this.$message({ type: 'success', message: '批量提交成功' });
                    this.$emit('confirm');
                } else {
                    this.$message({ type: 'error', message: '批量提交失败' });
                }
            });
        },
    },
};
</script>

<style scoped>
.el-button {
    margin-bottom: 5px;
}
.el-select {
    width: 100%;
    margin: 10px 0 0 0;
}
</style>
